import { mapEntitySyncConfigurationApiModelToConstructor } from './mapEntitySyncConfigurationApiModelToConstructor'
import type { IntegrationConstructor } from '../../entities/Integration/Integration'
import type { IntegrationApiModel } from '../api-models/IntegrationApiModel'

/**
 * Maps API model data to Integration constructor interface.
 * Handles snake_case to camelCase conversion and data transformation.
 */
export const mapIntegrationApiModel = (
  integrationApiModel: IntegrationApiModel
): IntegrationConstructor => {
  return {
    id: integrationApiModel.id,
    name: integrationApiModel.name,
    status: integrationApiModel.status,
    entitySyncConfigurations:
      integrationApiModel.entity_sync_configurations.map((config) =>
        mapEntitySyncConfigurationApiModelToConstructor(config)
      ),
  }
}
